import React from 'react';
import './StatsCard.css';

const StatsCard = () => {
  return (
    <div
      className="stats-card"
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')`
      }}
    >
      {/* 150+ Certified Tutors Card */}
      <div className="stats-card__item">
        <span className="stats-card__value">150+</span>
        <div className="stats-card__rating stats-card__rating--stars">
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
        </div>
        <span className="stats-card__label">Certified Tutors</span>
      </div>

      {/* 4.6 Rating from 5,000+ Reviews */}
      <div className="stats-card__item">
        <span className="stats-card__value">4.6</span>
        <div className="stats-card__rating stats-card__rating--stars">
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
        </div>
        <span className="stats-card__label">5,000+ Reviews</span>
      </div>

      {/* 12+ Years Experience Card */}
      <div className="stats-card__item">
        <span className="stats-card__value">12+</span>
        <div className="stats-card__rating stats-card__rating--hearts">
          <span className="stats-card__heart">❤️</span>
          <span className="stats-card__heart">❤️</span>
          <span className="stats-card__heart">❤️</span>
          <span className="stats-card__heart">❤️</span>
        </div>
        <span className="stats-card__label">Years Teaching Online</span>
      </div>
      {/* 4th Box: Reviewed On Platforms */}
      <div className="stats-card__item">
        <span className="stats-card__value">4+</span>
        <div className="stats-card__rating stats-card__rating--stars">
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
          <span className="stats-card__star">⭐</span>
        </div>
        <span className="stats-card__label stats-card__label--multiline">
          Reviewed on Trustpilot, Google, Clutch & Reviews.io
        </span>
      </div>

      {/* Right side text */}
      <div className="stats-card__text-container">
        <h3 className="stats-card__text">
          Why Families Choose Al Quran Lesson
        </h3>
      </div>
    </div>
  );
};

export default StatsCard;


